/**
 * Mindful Pause Prompts
 *
 * These prompts are shown to children while waiting for AI responses
 * to encourage mindfulness and prevent instant gratification habits.
 */

export const MINDFUL_PAUSE_PROMPTS = [
  {
    id: 1,
    text: "Let's take 3 deep breaths together. Inhale slowly… and exhale… Nice and calm."
  },
  {
    id: 2,
    text: "Look away from your screen for a moment. Find something across the room and focus on it."
  },
  {
    id: 3,
    text: "Roll your shoulders gently back and forth. Loosen up while we check your answer."
  },
  {
    id: 4,
    text: "Let your hands go floppy, then take a big stretch up to the sky. Shake it out!"
  },
  {
    id: 5,
    text: "Close your eyes for just a second and relax your face. Unclench your jaw."
  },
  {
    id: 6,
    text: "Let's try a focus trick: Take a deep breath in… hold… and breathe out slowly."
  },
  {
    id: 7,
    text: "Look around and quietly notice 3 things you can see or hear. Just observe."
  },
  {
    id: 8,
    text: "Count slowly in your mind from 1 to 5… then back from 5 to 1. Steady and smooth."
  },
  {
    id: 9,
    text: "Imagine you're in a calm place—like floating on a cloud or walking through a forest."
  },
  {
    id: 10,
    text: "Wiggle your fingers or tap your knees gently while you wait—then relax."
  }
];

/**
 * Get a random mindful pause prompt
 * @param {number} excludeId - Optional ID to exclude from selection (prevents consecutive duplicates)
 * @returns {Object} A random prompt with id and text
 */
export const getRandomPrompt = (excludeId = null) => {
  let availablePrompts = MINDFUL_PAUSE_PROMPTS;

  // Filter out excluded prompt if provided
  if (excludeId !== null && excludeId !== undefined) {
    const filtered = availablePrompts.filter(p => p.id !== excludeId);
    if (filtered.length > 0) {
      availablePrompts = filtered;
    }
  }

  // Return random prompt
  const randomIndex = Math.floor(Math.random() * availablePrompts.length);
  return availablePrompts[randomIndex];
};
